// LIBRARIES //
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { AntdButton } from '@yuhuinc/ui-library';
import Lottie from 'react-lottie';

// COMPONENTS
import DrawerMessage from '../DrawerMessage';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import successAnimationData from 'assets/success.json';
import { primaryButtonColors } from '../ButtonColors';

// ACTIONS //
import { hideInvitedDrawer } from '../store/actions';

const BodyText = styled.div`
  font-size: 16px;
  margin-left: 137px;
  margin-right: 137px;
`;

const successOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const InvitedDrawer = ({ hideInvitedDrawer, firstName }) => {
  const drawerData = {
    headerImageSource: <Lottie options={successOptions} height={150} width={150} />,
    headerText: getTranslatedString('residentDrawer.success'),
    bodyText: (
      <BodyText>
        {getTranslatedString('residentDrawer.residentDetailTab.invite.success', {
          first_name: firstName,
        })}
      </BodyText>
    ),
    cta: (
      <AntdButton
        type="primary"
        label={getTranslatedString('residentDrawer.close')}
        onClick={hideInvitedDrawer}
        style={primaryButtonColors}
      />
    ),
  };

  return <DrawerMessage {...drawerData} />;
};

export default connect(
  store => ({ showOptOutResident: store.landlord.residentDrawer.showOptOutResident }),
  { hideInvitedDrawer }
)(InvitedDrawer);
